module.exports = __webpack_public_path__ + "static/media/big-info-icon.704605a1.svg";